import {
  SYS_BREAKPOINT_MD,
  SYS_COLOR_SURFACE_NEUTRAL_800_LIGHT,
  SYS_COLOR_SURFACE_NEUTRAL_200_DARK,
} from '@oneaudi/unified-web-common';
import styled from 'styled-components';

export const StyledImage = styled.img`
  width: 100%;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
`;

export const StyledPicture = styled.picture`
  font-size: 0;
`;

export const ImageContainer = styled.div<{ photoImage: boolean }>`
  background-color: ${(props) =>
    props.photoImage ? SYS_COLOR_SURFACE_NEUTRAL_800_LIGHT : SYS_COLOR_SURFACE_NEUTRAL_200_DARK};
  width: 100%;
  height: 100%;
  text-align: center;
  font-size: 0;

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    aspect-ratio: 4/3;
  }
`;
